import { Colors } from 'Theme'
import { IFSkeleton, IFText } from 'Components'
import React, { forwardRef } from 'react'

import AuthSelectors from 'Stores/Auth/Selectors'
import ChargePointSelectors from 'Stores/ChargePoint/Selectors'
import ChargePointTariff from './ChargePointTariff/ChargePointTariff'
import InfinityEnums from 'Enums/InfinityEnums'
import PropTypes from 'prop-types'
import RequestState from 'Enums/RequestState'
import StationSelectors from 'Stores/Station/Selectors'
import Styles from './TariffContainer.module.css'
import TariffModalContainer from './TariffModalContainer/TariffModalContainer'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

const TariffContainer = forwardRef(
  (
    {
      isEditing,
      renderFor,
      maxListHeight,
      scrollbarsHeight,
      fetchStationListRequestState,
      fetchChargePointListRequestState,
      fetchChargePointRequestState,
      fetchChargePointTariffsRequestState,
      onModalSubmit,
      style,
      removeExtraMargin = false,
      operator,
    },
    ref,
  ) => {
    const { t } = useTranslation()

    const isLoading = () => {
      return renderFor === InfinityEnums.ChargePointSpecsContainer.CHARGEPOINT
        ? fetchStationListRequestState === RequestState.LOADING ||
            fetchChargePointListRequestState === RequestState.LOADING ||
            fetchChargePointRequestState === RequestState.LOADING ||
            fetchChargePointTariffsRequestState === RequestState.LOADING
        : false
    }

    return (
      <div
        className={Styles.TariffsContainer}
        {...(style ? { style: style } : {})}
      >
        <div className={Styles.TitleIconsContainer}>
          <div className={Styles.TitleContainer}>
            {isLoading() ? (
              <IFSkeleton variant="text" width="5rem" height="1.5rem" />
            ) : (
              <IFText
                style={{ color: Colors.text }}
                className={Styles.PriceTitle}
              >
                {t('TariffList.Name')}
              </IFText>
            )}
          </div>
          <div className={Styles.IconsContainer}>
            <div className={Styles.ChargingIconsContainer}>
              {isLoading() ? (
                <IFSkeleton variant="text" width="1rem" height="1rem" />
              ) : (
                <IFText style={{ fontWeight: 600, color: Colors.black }}>
                  {t('TariffList.Price')} ({operator.country.currency.code})
                </IFText>
              )}
            </div>
          </div>
        </div>
        {renderFor === InfinityEnums.ChargePointSpecsContainer.CHARGEPOINT ? (
          <ChargePointTariff
            ref={ref}
            isEditing={isEditing}
            maxListHeight={maxListHeight}
            removeExtraMargin={removeExtraMargin}
          />
        ) : renderFor === InfinityEnums.ChargePointSpecsContainer.MODAL ? (
          <TariffModalContainer
            ref={ref}
            isEditing={isEditing}
            maxListHeight={maxListHeight}
            scrollbarsHeight={scrollbarsHeight}
            onModalSubmit={onModalSubmit}
            removeExtraMargin={removeExtraMargin}
          />
        ) : null}
      </div>
    )
  },
)

const mapStateToProps = (state) => ({
  fetchChargePointTariffsRequestState:
    ChargePointSelectors.getFetchChargePointTariffsRequestState(state),
  fetchChargePointRequestState:
    ChargePointSelectors.getFetchChargePointRequestState(state),
  fetchStationListRequestState:
    StationSelectors.getFetchStationListRequestState(state),
  fetchChargePointListRequestState:
    ChargePointSelectors.getFetchChargePointListRequestState(state),
  operator: AuthSelectors.getOperator(state),
})

TariffContainer.propTypes = {
  fetchStationListRequestState: PropTypes.number,
  fetchChargePointListRequestState: PropTypes.number,
  chargePoint: PropTypes.object,
  fetchChargePointRequestState: PropTypes.number,
  isEditing: PropTypes.bool,
  renderFor: PropTypes.number,
  maxListHeight: PropTypes.any,
  scrollbarsHeight: PropTypes.any,
  tariffsListRef: PropTypes.object,
  fetchChargePointTariffsRequestState: PropTypes.number,
  onModalSubmit: PropTypes.func,
}

export default connect(mapStateToProps, null, null, {
  forwardRef: true,
})(TariffContainer)
